import { gql } from "@apollo/client";

export default gql`
  query getOrganizationNotifications($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      slackNotifications {
        edges {
          node {
            id
            channel
            recognitions
            goalCheckins
          }
        }
      }
      hasSlackConnection
      hasTeamsNotificationConnection
      publicSlackChannels {
        edges {
          node {
            id
            name
          }
        }
      }
      teamsNotifications {
        edges {
          node {
            id
            teamId
            teamName
            channelId
            channelName
            recognitions
            goalCheckins
          }
        }
      }
      availableTeamsNotificationChannels {
        teamId
        teamName
        channelId
        channelName
      }
    }
  }
`;
